// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartist-tooltip{position:absolute;background:#f8f8fb;padding:2px 10px}`, "",{"version":3,"sources":["webpack://./resources/app/modules/dashboards/Widgets/StatChartWidget/index.scss"],"names":[],"mappings":"AAAA,kBACE,iBAAA,CACA,kBAAA,CACA,gBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
